var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalud2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Salud",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90.2 76.2",
    style: {
      enableBackground: "new 0 0 90.2 76.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M0.5,17.6c0.4,0.9,1.4,1.3,2.3,1c0.9-0.4,1.3-1.4,1-2.3c-0.4-0.9-1.4-1.3-2.3-1 c-0.1,0-0.2,0.1-0.3,0.1C0.5,15.9,0.2,16.8,0.5,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st0",
    d: "M73.1,31.1c0.2-0.4,0.3-0.9,0.5-1.3c1-3,1.4-6.1,1.2-9.2C74.4,15,71.9,9.8,67.8,6 C64,2.3,58.9,0.2,53.6,0c-7.4,0-13.2,4.1-15.9,6.6c-0.2,0.2-0.5,0.2-0.7,0C34,4.1,28.1,0,21,0C15.2,0,8.9,3.2,4.8,8.3 C4.1,9,4.2,10.1,5,10.7c0.8,0.6,1.9,0.5,2.5-0.2c3.5-4.3,8.7-7,13.6-7c6,0,11.1,3.6,13.6,5.7c1.5,1.3,3.8,1.3,5.3,0 c2.4-2.1,7.4-5.7,13.6-5.7c8,0,17.2,7.4,17.7,17.2c0.1,2.7-0.2,5.4-1.1,7.9c-0.2,0.6-0.4,1.2-0.7,1.8c-0.7-0.1-1.4-0.1-2.1-0.1 c-12.6,0.1-22.8,10.3-22.8,22.9c0,0.6,0,1.2,0.1,1.8c-1.7,1.4-3.2,2.6-4.3,3.6c-1.8,1.5-4.4,1.5-6.2,0c-1.6-1.4-3.7-3-5.9-4.8 C20.4,47.4,9.5,38.5,6.9,34.1c-1.6-2.6-2.7-5.4-3.2-8.3c-0.1-0.3-0.1-0.6-0.2-1c-0.1-1-1-1.7-2-1.5c-1,0.1-1.7,1-1.5,2c0,0,0,0,0,0 c0,0.4,0.1,0.8,0.2,1.1c0.6,3.4,1.9,6.6,3.7,9.5c2.9,5,13.6,13.7,22.2,20.7c2.2,1.8,4.2,3.5,5.8,4.8c3.1,2.6,7.6,2.6,10.7,0 c0.8-0.7,1.7-1.4,2.7-2.3c3.3,12.2,15.8,19.3,27.9,16.1s19.3-15.8,16.1-27.9C87.3,39.3,81,33.2,73.1,31.1L73.1,31.1z M67.4,72.7 c-10.7,0.1-19.5-8.5-19.6-19.2S56.3,34,67.1,33.9s19.5,8.5,19.6,19.2c0,0.1,0,0.1,0,0.2C86.7,64,78.1,72.7,67.4,72.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    className: "st0",
    d: "M75.8,47.3h-2.4v-2.5c0-2.2-1.7-3.9-3.9-3.9h-4.2c-2.2,0-3.9,1.8-3.9,3.9v2.5H59 c-2.2,0-3.9,1.8-3.9,3.9v4.3c0,2.2,1.7,3.9,3.9,3.9h2.4v2.5c0,2.2,1.7,3.9,3.9,3.9h4.2c2.2,0,3.9-1.8,3.9-3.9v-2.5h2.4 c2.2,0,3.9-1.8,3.9-3.9v-4.3C79.7,49,78,47.3,75.8,47.3z M76.2,55.4c0,0.2-0.2,0.4-0.4,0.4h-4.2c-1,0-1.8,0.8-1.8,1.8v4.2 c0,0.2-0.2,0.4-0.4,0.4h-4.2c-0.2,0-0.4-0.2-0.4-0.4v-4.2c0-1-0.8-1.8-1.8-1.8H59c-0.2,0-0.4-0.2-0.4-0.4v-4.3 c0-0.2,0.2-0.4,0.4-0.4h4.2c1,0,1.8-0.8,1.8-1.8v-4.2c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h4.2c0.2,0,0.4,0.2,0.4,0.4c0,0,0,0,0,0V49 c0,1,0.8,1.8,1.8,1.8c0,0,0,0,0,0h4.2c0.2,0,0.4,0.2,0.4,0.4V55.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalud2);
export default __webpack_public_path__ + "static/media/Salud2.a114156112f3f218fc2cc3e9f0d941c8.svg";
export { ForwardRef as ReactComponent };